//  学习班类型相关 api
import request from '@/api/request'

// 获取修改页面数据
export function editInitApi(id:string){
    let url = '/api/manager/studyclasstype/edit/init';
    let data = {
        "id":id
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 更新修改页面
export function editSaveApi(data:any){
    let url = '/api/manager/studyclasstype/edit/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 增加文章
export function editAddApi(data:any){
    let url = '/api/manager/studyclasstype/save';
    return request({
        url: url,
        method: 'post',
        data
    })
}

// 获取学习班类型列表
export function optionsApi(data:any){
    let url = '/api/manager/studyclasstype/options';
    return request({
        url: url,
        method: 'post',
        data
    })
}